export const openSidebar = () => {
    if (typeof document !== 'undefined') {
        document.body.style.overflow = 'hidden';
        document.documentElement.style.setProperty(
            '--rwl-sidebar-visible',
            '1'
        );
    }
};

export const closeSidebar = () => {
    if (typeof document !== 'undefined') {
        document.documentElement.style.removeProperty('--rwl-sidebar-visible');
        document.body.style.removeProperty('overflow');
    }
};

export const toggleSidebar = () => {
    if (typeof window !== 'undefined' && typeof document !== 'undefined') {
        const slideIn = window
            .getComputedStyle(document.documentElement)
            .getPropertyValue('--rwl-sidebar-visible');
        if (slideIn) {
            closeSidebar();
        } else {
            openSidebar();
        }
    }
};

export const openMap = () => {
    if (typeof document !== 'undefined') {
        document.body.style.overflow = 'hidden';
        document.documentElement.style.setProperty(
            '--rwl-job-list-visible',
            '1'
        );
    }
};

export const closeMap = () => {
    if (typeof document !== 'undefined') {
        document.documentElement.style.removeProperty('--rwl-job-list-visible');
        document.body.style.removeProperty('overflow');
        document.documentElement.className = '';
    }
};

export const isShowingJobList = () => {
    return !!window
        .getComputedStyle(document.documentElement)
        .getPropertyValue('--rwl-job-list-visible');
};

export const toggleMap = () => {
    if (typeof window !== 'undefined' && typeof document !== 'undefined') {
        const slideIn = window
            .getComputedStyle(document.documentElement)
            .getPropertyValue('--rwl-job-list-visible');
        if (slideIn) {
            closeMap();
        } else {
            openMap();
        }
    }
};
